export { SidekickView } from "./SidekickView"
export { AvatarMode, AvatarOverlay, useAvatarVisibility } from "./AvatarOverlay"
export { NavigationControls } from "./NavigationControls"
export { PlaybackControls, PlaybackLeftControls } from "./PlaybackControls"
export type {
  ControlsConfig,
  ControlsConfigType,
  NavigationControlsConfig,
  NoControlsConfig,
  PlaybackControlsConfig,
  SidekickViewProps,
} from "./types"
